import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const colorStyle = 'dark'
export const POST_SHADOW = '0px 4px 4px rgba(0, 0, 0, 0.12);'
export const MAC13_COLORED_FONT_SIZE = 26
export const FontSizes = {
  common: {
    m: { fs: 17, lh: 22 }
  },
  bigText: {
    // m: { fs: 28.5, lh: 35 }
    xxxl: { fs: 84, lh: 88 },
    xxl: { fs: 60, lh: 70 },
    xl: { fs: 52, lh: 56 },
    l: { fs: 42, lh: 48 },
    m: { fs: 29, lh: 39.5 },
    s: { fs: 28, lh: 34 },
    xs: { fs: 22, lh: 28 }
  },
  regularText: {
    m: { fs: 16, lh: 24 }
  },
  tag: {
    l: { fs: 17, lh: 22 },
    m: { fs: 15, lh: 20 },
    s: { fs: 13, lh: 16 },
    bigSize: {
      l: { fs: 42, lh: 48 },
      m: { fs: 29, lh: 40 },
      s: { fs: 22, lh: 28 },
    }
  },

  captionText: {
    m: { fs: 20, lh: 32 },
    s: { fs: 17, lh: 22 },
    xs: { fs: 15, lh: 20 }
  },

  input: {
    l: { fs: 17, lh: 22 },
    m: { fs: 15, lh: 20 },
    s: { fs: 13, lh: 16 },
  }
}


export const biggestFontStyles = css`
    font-size: ${FontSizes.bigText.xxxl.fs}px;
    line-height: ${FontSizes.bigText.xxxl.lh}px;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        font-size: ${FontSizes.bigText.xl.fs}px;
        line-height: ${FontSizes.bigText.xl.lh}px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: ${FontSizes.bigText.s.fs}px;
        line-height: ${FontSizes.bigText.s.lh}px;
    }

    @media (max-width: ${LayoutConst.container.s -1}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }
`;

export const bigFontStyles = css`
    font-size: ${FontSizes.bigText.xxl.fs}px;
    line-height: ${FontSizes.bigText.xxl.lh}px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        font-size: ${FontSizes.bigText.l.fs}px;
        line-height: ${FontSizes.bigText.l.lh}px;
    }

        font-size: ${FontSizes.bigText.l.fs}px;
        line-height: ${FontSizes.bigText.l.lh}px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }

    @media (max-width: ${LayoutConst.container.s -1}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }
`;

export const regularFontStyles = css`
    font-size: ${FontSizes.bigText.l.fs}px;
    line-height: ${FontSizes.bigText.l.lh}px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: ${FontSizes.bigText.m.fs}px;
        line-height: ${FontSizes.bigText.m.lh}px;
    }

    @media (max-width: ${LayoutConst.container.s -1}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }
`;

import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const colorStyle = 'dark'
export const POST_SHADOW = '0px 4px 4px rgba(0, 0, 0, 0.12);'
export const MAC13_COLORED_FONT_SIZE = 26
export const FontSizes = {
  common: {
    m: { fs: 17, lh: 22 }
  },
  bigText: {
    // m: { fs: 28.5, lh: 35 }
    xxxl: { fs: 84, lh: 88 },
    xxl: { fs: 60, lh: 70 },
    xl: { fs: 52, lh: 56 },
    l: { fs: 42, lh: 48 },
    m: { fs: 29, lh: 39.5 },
    s: { fs: 28, lh: 34 },
    xs: { fs: 22, lh: 28 }
  },
  regularText: {
    m: { fs: 16, lh: 24 }
  },
  tag: {
    l: { fs: 17, lh: 22 },
    m: { fs: 15, lh: 20 },
    s: { fs: 13, lh: 16 },
    bigSize: {
      l: { fs: 42, lh: 48 },
      m: { fs: 29, lh: 40 },
      s: { fs: 22, lh: 28 },
    }
  },

  captionText: {
    m: { fs: 20, lh: 32 },
    s: { fs: 17, lh: 22 },
    xs: { fs: 15, lh: 20 }
  },

  input: {
    l: { fs: 17, lh: 22 },
    m: { fs: 15, lh: 20 },
    s: { fs: 13, lh: 16 },
  }
}


export const biggestFontStyles = css`
    font-size: ${FontSizes.bigText.xxxl.fs}px;
    line-height: ${FontSizes.bigText.xxxl.lh}px;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        font-size: ${FontSizes.bigText.xl.fs}px;
        line-height: ${FontSizes.bigText.xl.lh}px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: ${FontSizes.bigText.s.fs}px;
        line-height: ${FontSizes.bigText.s.lh}px;
    }

    @media (max-width: ${LayoutConst.container.s -1}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }
`;

export const bigFontStyles = css`
    font-size: ${FontSizes.bigText.xxl.fs}px;
    line-height: ${FontSizes.bigText.xxl.lh}px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        font-size: ${FontSizes.bigText.l.fs}px;
        line-height: ${FontSizes.bigText.l.lh}px;
    }

        font-size: ${FontSizes.bigText.l.fs}px;
        line-height: ${FontSizes.bigText.l.lh}px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }

    @media (max-width: ${LayoutConst.container.s -1}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }
`;

export const regularFontStyles = css`
    font-size: ${FontSizes.bigText.l.fs}px;
    line-height: ${FontSizes.bigText.l.lh}px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: ${FontSizes.bigText.m.fs}px;
        line-height: ${FontSizes.bigText.m.lh}px;
    }

    @media (max-width: ${LayoutConst.container.s -1}px) {
        font-size: ${FontSizes.bigText.xs.fs}px;
        line-height: ${FontSizes.bigText.xs.lh}px;
    }
`;

